// Query-string serialization of axios 0.21, kept as is for axios 1.x.
//
// The Rails side depends on it: nested objects arrive as one JSON string (`filters={"city_id":5}`) that controllers read
// with `JSON.parse(params[:filters]) rescue {}` (maps search, number_of_actions, headquarters registered hotels).
// axios 1.x would expand them to `filters[city_id]=5`, so those filters would be dropped without any error.
// Arrays stay `ids[]=1&ids[]=2` with literal brackets. test/store/api_wire_format.spec.js pins the exact output.
const encode = (value) =>
  encodeURIComponent(value)
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+')
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']');

const scalar = (value) => {
  if (Object.prototype.toString.call(value) === '[object Date]') return value.toISOString();
  if (value !== null && typeof value === 'object') return JSON.stringify(value);
  return value;
};

export function serializeParams(params) {
  if (typeof URLSearchParams !== 'undefined' && params instanceof URLSearchParams) return params.toString();

  const parts = [];
  Object.keys(params).forEach((name) => {
    const value = params[name];
    if (value === null || typeof value === 'undefined') return;

    const key = Array.isArray(value) ? `${name}[]` : name;
    (Array.isArray(value) ? value : [value]).forEach((item) => {
      parts.push(`${encode(key)}=${encode(scalar(item))}`);
    });
  });
  return parts.join('&');
}

export default serializeParams;
